<template>
  <div class="Login">
    <h2 class="text-center">
        <img src="/images/logo-taes.gif" alt="">
    </h2>

    <form class="Login__form" @submit.prevent="login">

      <BfInput
        data-key="email"
        label="Email"
        v-model="email"
        type="email"
        :left-border="false"
      />

      <BfInput
        data-key="password"
        label="Contraseña"
        v-model="password"
        type="password"
        :left-border="false"
      />

      <BfButton type="submit" :disabled="loading">
        Entrar

        <i v-if="loading" class="fas fa-spinner fa-spin fa-lg ml-2"></i>
      </BfButton>
    </form>

    <transition name="fade">
      <div v-if="error" class="Login__error">
        <hr>
        <h4 class="text-danger">¡Algo falla!</h4>
        <p class="text-danger">El Usuario o la Contraseña no son validos</p>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { LOGIN } from '@/store/modules/auth';

export default {
  name: 'login',

  data() {
    return {
      email: '',
      password: '',
      error: null,
    };
  },

  methods: {
    async login() {
      this.error = null;

      try {
        await this.$store.dispatch(`auth/${LOGIN}`, {
          username: this.email,
          password: this.password,
        });
      } catch (err) {
        this.error = err;
      }
    },
  },

  computed: mapState({
    loading: ({ auth }) => auth.authenticating,
    user: ({ auth }) => auth.user,
  }),
};
</script>

<style lang="scss">
.Login {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 10px;

  .Login__form {
    width: 400px;
    max-width: 100%;
    margin-top: 32px;
  }

  .Login__error {
    width: 400px;
    max-width: 100%;
  }

  #app.-is-mobile & {
    padding: 30px 20px;
    justify-content: flex-start;
  }
}
</style>
